import { connect } from 'react-redux';
import Home from '../components/Home';
import * as actions from '../actions/map';
import * as toolsActions from '../actions/tools';

const mapStateToProps = state => ({
  selectedTool: state.map.selectedTool,
  videoToolSelected: state.tools.videoToolSelected,
});

const mapDispatchToProps = dispatch => ({
  onSelectTool: tool => dispatch(actions.selectTool(tool)),
  onSelectDay: day => dispatch(actions.selectDay(day)),
  onSelectUsersTool: () => dispatch(actions.selectTool('users')),
  onSelectVideoTool: () => dispatch(toolsActions.toggleVideoTool()),
  onCloseVideoTool: () => dispatch(toolsActions.selectVideoTool(false)),
  onSelectReportsTool: () => dispatch(actions.selectTool('reports')),
  onSelectAdsTool: () => dispatch(actions.selectTool('ads')),
  onCloseTool: () => dispatch(actions.selectTool()),
  onLogout: () => dispatch(actions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js